






























































































































































































import { Component, Vue } from "vue-property-decorator";
import { Indicator, IndicatorTable } from "@/models/Indicator";
import {
  INDICATOR_TABLE_REQUEST,
  INDICATOR_TABLE_VERIFY,
  INDICATOR_TABLE_DELETE,
} from "@/store/actions/indicatorTable";
import { Region } from "@/models/Region";
import { REGION_REQUEST, REGION_LOADED } from "@/store/actions/main";

@Component({})
export default class IndicatorsTables extends Vue {
  private indicatorsTables: IndicatorTable[] = [];
  private indicatorsTablesHeaders = [
    {
      text: "Название",
      value: "indicator_table_name",
      align: "start",
      width: "60%",
    },
    {
      text: "Регион",
      value: "region_id",
      align: "start",
      width: "15%",
    },
    {
      text: "Верификация",
      value: "verified",
      align: "start",
      width: "10%",
    },
    {
      text: "Действия",
      value: "actions",
      align: "center",
      sortable: false,
      width: "15%",
    },
  ];
  private loading: boolean = false;
  private search = "";
  private region = "";
  private regions: any[] = [];
  private indicator_table_name = "";
  private itemToDelete: IndicatorTable = new IndicatorTable();
  private deleteDialog: boolean = false;
  private deleteSnackbar: boolean = false;
  private deleteDisabled: boolean = false;
  //verify
  private verifyingItems: number[] = [];
  private verifier: boolean = false;
  //options
  private tablePage = 1;
  private tablePageCount = 0;
  private itemsPerPage = 15;

  //Initialise methods
  private initIfReady() {
    //return true if started to init self.
    let needReload = [] as boolean[];
    needReload.push(
      this.needReload(
        this.$store.getters.INDICATOR_TABLE_TABLE,
        this.$store.getters.INDICATOR_TABLE_LOADED
      )
    );
    needReload.push(
      this.needReload(
        this.$store.getters.REGION_TABLE,
        this.$store.getters.REGION_LOADED
      )
    );
    for (let i = 0; i < needReload.length; i++) {
      if (needReload[i] == true) {
        return false;
      }
    }
    console.log("TRUE INIT SELF");
    this.initSelf();
    return true;
  }
  private needReload(table, updated) {
    /*
		data is a table loading from request.
		updated is flag that is false when table has old data and need to be reloading.
		return true if need reload.
		*/
    if (table == null || !updated) return true;
    return false;
  }
  private tryToInitSelf() {
    this.loading = true;
    //const data = this.getParams();
    if (this.initIfReady()) return;

    if (
      this.needReload(
        this.$store.getters.INDICATOR_TABLE_TABLE,
        this.$store.getters.INDICATOR_TABLE_LOADED
      )
    ) {
      this.$store.dispatch(INDICATOR_TABLE_REQUEST).then(() => {
        this.initIfReady();
      });
    }
    if (
      this.needReload(
        this.$store.getters.REGION_TABLE,
        this.$store.getters.REGION_LOADED
      )
    ) {
      this.$store.dispatch(REGION_REQUEST).then(() => {
        this.initIfReady();
      });
    }
  }
  private initSelf() {
    console.log("INIT SELF");
    this.indicatorsTables = this.$store.getters.INDICATOR_TABLE_TABLE.data;
    this.regions = this.$store.getters.REGION_TABLE.data;
    if (localStorage.getItem("role") == "Verifer") {
      this.verifier = true;
    }
    this.loading = false;
    console.log("loading");
  }
  //Methods
  private verify(item) {
    let v = item.verified as boolean;
    v = !v;
    let data = {
      id: +item.id,
      params: {
        v: v,
      },
    };
    this.verifyingItems.push(+item.id);
    this.$store.dispatch(INDICATOR_TABLE_VERIFY, data).then(() => {
      this.tryToInitSelf();
      for (let i = 0; i < this.verifyingItems.length; i++) {
        if (+item.id == this.verifyingItems[i]) {
          this.verifyingItems.splice(i, 1);
        }
      }
    });
  }
  private isVerifying(id) {
    if (!this.verifier) return true;
    for (let i = 0; i < this.verifyingItems.length; i++) {
      if (id == this.verifyingItems[i]) {
        return true;
      }
    }
    return false;
  }
  private isDeleting(id) {
    if (this.itemToDelete.id == id) return true;
    return false;
  }
  private cleanDeleting() {
    this.itemToDelete = new IndicatorTable();
  }
  private toCreate() {
    this.$router.push({ name: "IndicatorsTablesCreate" });
  }
  private toEdit(item) {
    console.log("item: ", item);
    const parsed = JSON.stringify(item);
    localStorage.setItem("indicatorsTablesToEdit", parsed);
    this.$router.push({
      name: "IndicatorsTablesUpdate",
      params: { id: item.id },
    });
  }
  private deleteItem(item: IndicatorTable, confirmation: boolean) {
    this.itemToDelete = item;
    if (confirmation) {
      this.deleteDialog = true;
    } else {
      console.log(item);
      console.log("Delete!");
      this.$store.dispatch(INDICATOR_TABLE_DELETE, item.id).then(() => {
        this.tryToInitSelf();
        this.deleteSnackbar = true;
        this.itemToDelete = new Indicator();
        this.deleteDisabled = false;
      });
      this.deleteDialog = false;
    }
  }
  private getRegion(id){
    for(let i = 0; i < this.regions.length; i++){
      if(id == this.regions[i].id)
        return this.regions[i].title
    }
  }
  //Hooks
  private mounted() {
    this.tryToInitSelf();
  }
  private nameSearch(value, search, item): boolean {
    return (
      value != null &&
      search != null &&
      typeof value === "string" &&
      value
        .toString()
        .toLocaleLowerCase()
        .indexOf(search.toString().toLocaleLowerCase()) !== -1
    );
  }
}
